import { useIsLoadingAppData } from "@/react/hooks/useIsLoadingAppData";
import { CommunitySwitcher } from "@circle-react/components/CommunitySwitcher/CommunitySwitcher";

export const CommunitySwitcherAppData = () => {
  const isLoadingAppData = useIsLoadingAppData();
  return <CommunitySwitcher isLoadingAppData={isLoadingAppData} />;
};
